import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import AOS from 'aos'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import App from './App'
import router from './router'
import store from './store/index'
import iziToast from './utils/iziToaster'
import Icon from 'vue-awesome/components/Icon'
import VeeValidate from 'vee-validate'
import { FlowerSpinner } from 'epic-spinners'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/style.css'
import './assets/css/scrollbar.css'
import './assets/css/paginate.css'
import './assets/css/responsive-mobile.css'
import './assets/css/profile-tabs-common.css'
import './assets/css/profile-enhancements.css'
import './assets/css/cu-global-theme.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-awesome/icons'
import './utils/Interceptor'
import 'font-awesome/css/font-awesome.min.css'

import './theme-assets/css/bootstrap.css'

import './theme-assets/css/color-3.css'
import './theme-assets/css/owl.carousel.min.css'
import './theme-assets/css/owl.theme.default.min.css'
import './theme-assets/css/fontawesome.css'
import './theme-assets/css/themify.css'
import './theme-assets/css/flaticon.css'
import './theme-assets/css/magnific-popup.css'
require('./theme-assets/js/jquery-3.3.1.min.js')
require('popper.js');
require('bootstrap');
require('./theme-assets/js/custamizer-option.js')

require('./theme-assets/js/magnific-popup.js')
require('./theme-assets/js/typed.min.js')
require('./theme-assets/js/owl.carousel.min.js')
require('./theme-assets/js/typed.js')
require('./theme-assets/js/vanilla-tilt.min.js')
require('./theme-assets/js/jquery.counterup.min.js')
require('./theme-assets/js/jquery.waypoints.min.js')
require('./theme-assets/js/main.js')
require('./theme-assets/js/counters.js')
require('./theme-assets/js/script3.js')
require('./theme-assets/js/layout-fix.js')

Vue.use(BootstrapVue)
Vue.use(iziToast)
Vue.use(VeeValidate)

Vue.component(moment)
Vue.component('icon', Icon)
Vue.component('paginate', Paginate)
Vue.component('global-spinner', FlowerSpinner)
AOS.init();
Vue.prototype.$moment = moment
Vue.prototype.$iziToast = iziToast

Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})
